module.exports = __webpack_public_path__ + "static/media/aboutme_img.af14c904.jpg";